import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import Button from "../../Components/Common/Button/Button";
import { ReactComponent as QuestionIcon } from "../../Assets/Icons/QuestionIcon.svg";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { connect } from "react-redux";
import { START_STATUS_PATIENT_UPDATE } from "../../Actions/PatientAction";
import { START_ORDER_COUNT_TYPE } from "../../Actions/RepeatOrderAction";
const useStyle = makeStyles((theme) => ({
  dialogMain: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      position: "absolute",
      top: "0 !important",
    },
    "& .MuiDialogTitle-root": {
      borderBottom: "none",
      "&>p": {
        "&>svg": {
          position: "relative",
          top: "18px",
          right: "28px",
        },
      },
    },
  },
  rsNoteGrid: {
    "&>div": {
      "&>div": {
        "&>div": {
          "&>h4": {
            fontSize: "15px !important",
            justifyContent: "center",
            display: "flex",
          },
        },
      },
    },
    "& .MuiTableBody-root": {
      "&>tr": {
        "&>td": {
          padding: "12px 17px !important",
        },
      },
    },
  },
  dialogActionBtn: {
    marginBottom: "10px",
    display: "flex !important",
    justifyContent: "center !important",
    "&>div": {
      paddingRight: "10px",
      "&>button": {
        color: "black",
      },
    },
  },
  labelWhiteSpaceNW: {
    marginTop: "20px !important",
    "&>span": {
      color: "black",
      whiteSpace: "nowrap",
    },
  },
  luIcon: {
    display: "flex !important",
    justifyContent: "center !important",
    marginBottom: "10px",
    marginTop: "20px",
  },
}));

const PatientActionColumn = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    getPatientStatusUpdatAction,
    patientId,
    statusUpdate,
    getList,
    patientStatus,
    getOrderCountTypeAction,
    orderCountPayload,
    countUpdateFlag,
  } = props;
  const [chaseUp, setChaseUp] = useState("active");
  const [loading, setLoading] = useState(false);
  const chaseUpList = [
    { label: "Active", value: "active" },
    { label: "Absent", value: "absent" },
    { label: "Deceased", value: "deceased" },
    { label: "In-Hospital", value: "in_hospital" },
  ];

  /**handle close dialog */
  const handleClose = () => {
    setOpen(false);
  };

  /** update setting  hour in api */
  const updateSettingAction = () => {
    let payload = {
      status: chaseUp,
    };
    getPatientStatusUpdatAction(patientId, payload);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
      if (countUpdateFlag) {
        getOrderCountTypeAction(orderCountPayload);
      }
    }, 1000);
  };

  //Success
  useEffect(() => {
    setChaseUp(patientStatus);
  }, [open]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"sm"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        className={classes.dialogMain}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <Box className={classes.rsNoteGrid}>
          <DialogContent>
            <Box className={classes.luIcon}>
              <PrimaryIcon
                //   handleClose={handleClose}
                //   title={"Global Settings"}
                icon={QuestionIcon}
              />
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography color="black" bold variant="h4">
                  Do you want to change the patient's status?
                </Typography>
                <Grid container display={"flex"} justifyContent={"center"}>
                  {chaseUpList?.map((item, index) => {
                    return (
                      <FormControlLabel
                        className={classes.labelWhiteSpaceNW}
                        value={item?.value}
                        key={index}
                        checked={chaseUp === item?.value}
                        onChange={(e, value) => {
                          setChaseUp(item?.value);
                        }}
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                            color="primary"
                          />
                        }
                        label={`${item?.label}`}
                      />
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className={classes.dialogActionBtn}>
            <Box>
              <Button
                //   children={actionBtnTitle}
                variant="contained"
                color="greybtn"
                onClick={() => handleClose()}
              >
                No, Cancel
              </Button>
            </Box>
            <Button
              disabled={loading}
              startIcon={
                loading && <CircularProgress color="white" size="20px" />
              }
              //   children={actionBtnTitle}
              variant="contained"
              color="primary"
              onClick={() => updateSettingAction()}
            >
              Yes, Change
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  statusUpdate: state.patient.statusUpdate,
});
const mapDispatchToProps = (dispatch) => ({
  getPatientStatusUpdatAction: (id, payload) =>
    dispatch({ type: START_STATUS_PATIENT_UPDATE, id, payload }),
  getOrderCountTypeAction: (payload) =>
    dispatch({ type: START_ORDER_COUNT_TYPE, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientActionColumn);
